export default __webpack_public_path__ + "static/media/phone_icon_yokara.061b1b62.png";